<template>
  <vue-apex-charts
    class="brdlnchart"
    ref="brandindexLineChart"
    type="line"
    height=450px
    min-height=450px
    :options="chartOptions"
    :series="series"
  />
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import debounce from "lodash";
import moment from "moment";

const colorMap = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", 
                  "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", 
                  "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", 
                  "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
const shapeMap = ['circle', 'triangle', 'square', 'sparkle', 'diamond'];

const bgcolorMap = ["#112233", "#667788"]

const localeFloatOpt = { minimumFractionDigits: 1, maximumFractionDigits: 1 }

const data_uri_neg = "data:image/png;base64,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"
const data_uri_pos = "data:image/png;base64,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"

let resizeObserver  = null
let mutationObserver  = null
let isUpdateGrid = false
 
export default {
  name: "BrandIndexLineChart",
  components: {
    VueApexCharts,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          id: this.chartID,
          type: "line",
          stacked: false,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 250,
            animateGradually: {
                enabled: true,
                delay: 100
            },
            dynamicAnimation: {
                enabled: true,
                speed: 50
            }
          },
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
          events: {
            mounted: async (chartCtx) => {
              this.waitForGrid(chartCtx.el)

              resizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => {
                  this.debouncedUpdate(chartCtx.el)
                })
              })

              resizeObserver.observe(chartCtx.el)
            },

            updated: async (chartCtx) => {
              if (isUpdateGrid) {
                isUpdateGrid = false
                return
              }

              this.waitForGrid(chartCtx.el)
            }
          }
        },
        dataLabels: {
          enabled: true,
          fontFamily: "NanumBarunGothic !important",
          textAnchor: 'middle',
          formatter: function (value, opt) {
            if (opt.w.globals.dom.baseEl.__vue__.series.length > 0 && 
                opt.w.globals.dom.baseEl.__vue__.series[opt.seriesIndex].label_dsp[opt.dataPointIndex] > 0) {
              if (opt.w.globals.chartID == 'comLnChart')
                return (Math.round(value * 10) / 10).toLocaleString();
              else
                return '';
            }
            else {
              if (opt.w.globals.chartID == 'comLnChart')
                return ''
              else 
                return (Math.round(value * 10) / 10).toLocaleString();
            }
          },
          offsetY: -5,
          background: {
            enabled: false
          },
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1.5,
          curve: 'smooth',
        },
        markers: {
          size: 4,
          hover: {
            size: 5
          }
        },
        xaxis: {
          categories: [],
          tooltip: {
            enabled: false,
          },
          crosshairs: {
            show: true,
            dropShadow: {
              enabled: true,
              top: 0,
              left: 0,
              blur: 0,
              opacity: 0.4,
            },
          },
        },
        yaxis: [
          {
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#008FFB",
            },
            labels: {
              style: {
                colors: "#008FFB",
              },
              formatter(value) {
                let val = Math.round(value * 10) / 10;

                if (val >= 10 ** 3 && val < 10 ** 6)
                  return (val / 1000).toFixed(1) + 'K';
                else if (val >= 10 ** 6)
                  return (val / 1000000).toFixed(1) + 'M';
                else
                  return (val).toLocaleString();
              },
            },
            title: {
              text: this.chartYaxisTitle,
              style: {
                color: "#008FFB",
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        ],
        tooltip: {
          followCursor: true,
          shared: false,
          intersect: true,
          enabled: true,
          fixed: {
            enabled: false,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            const seriesIdx = seriesIndex;
            const dataPtIdx = dataPointIndex;

            var hexColor = w.globals.colors[seriesIdx].replace('#', '')
            const r = parseInt(hexColor.substring(0, 2), 16)
            const g = parseInt(hexColor.substring(2, 4), 16)
            const b = parseInt(hexColor.substring(4, 6), 16)
            hexColor = `rgb(${r}, ${g}, ${b})`

            var val = Number(series[seriesIdx][dataPtIdx]).toLocaleString()

            return '<div>' +
                '<div class="apexcharts-tooltip-title" style="font-family: NanumBarunGothic; font-size: 12px;">' + w.globals.categoryLabels[dataPtIdx] + '</div>' +
                '<div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex;">' +
                '<span class="apexcharts-tooltip-marker" style="background-color: ' +  hexColor + ';"></span>' + 
                '<div class="apexcharts-tooltip-text" style="font-family: NanumBarunGothic; font-size: 12px;">' +
                '<div class="apexcharts-tooltip-y-group">' +
                '<span class="apexcharts-tooltip-text-label">' + w.globals.seriesNames[seriesIdx] + ' : ' + '</span>' +
                '<span class="apexcharts-tooltip-text-value">' + val + '</span>' +
                '</div>' +
                '<div class="apexcharts-tooltip-z-group">' +
                '<span class="apexcharts-tooltip-text-z-label"></span>' +
                '<span class="apexcharts-tooltip-text-z-value"></span>' +
                '</div></div></div></div>';
          },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "center",
          itemMargin: {
            horizontal: 5,
            vertical: 2,
          },
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          },
        },
        noData: {
          text: '분석중...',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            color: '#1817E7',
            fontSize: '20px',
            fontFamily: "NanumBarunGothicB"
          }
        },
      },

      series: [],

      debouncedResize: null,
      debouncedUpdate: null
    };
  },
  props: {
    brandindexLineChart: {
      type: Array,
      default: () => [],
    },
    chartCategories: {
      type: Array,
      default: () => [],
    },
    chartYaxisTitle: {
      type: String,
      default: 'Score',
    },
    isChartInit: {
      type: Boolean,
      default: false,
    },
    updateHighlight: {
      type: String,
      default: '',
    },
    chartID: {
      type: String,
      default: '',      
    }
  },
  watch: {
    brandindexLineChart(newVal) {
      if (!this.isChartInit) {
        const lineChartOption = {
          chart: {
            id: this.chartID,
          },
          noData: {
            text: '분석중...',
            style: {
              color: '#1817E7',
            }
          },
          annotations: {
            xaxis: [],
            points: [],
            texts: []
          },
        };

        this.$refs.brandindexLineChart.updateOptions(lineChartOption, true);

        return;
      } 

      if (newVal.length > 0) {   
        var colors = [];
        var shapes = [];
       
        for (let i = 0; i < newVal.length; i++) {
          shapes.push(shapeMap[Math.floor(i / colorMap.length) % shapeMap.length]);
          colors.push(colorMap[i % colorMap.length]);
        }

        var year_div = this.getYearDivision();
        var xaxis = [];
        var texts = [];
        var points = [];
        var bgColorIdx = 0;

        this.$nextTick(() => {
          const ctrlWidth = this.getCtrlRect().width / Number(this.chartCategories.length - 1);
          const margin = ctrlWidth / 2;

          for (let i = 0; i < year_div.length; i += 2) {
            var x1 = 0;
            var x2 = 0;

            var date = moment(this.chartCategories[year_div[i]])

            if (i == 0) {
              x1 = 0;
              x2 = Number(year_div[i + 1]) * ctrlWidth - margin;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }
            else if (i == year_div.length - 2) {
              x1 = Number(year_div[i]) * ctrlWidth - margin;
              x2 = Number(year_div[i + 1]) * ctrlWidth;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }
            else {
              x1 = Number(year_div[i]) * ctrlWidth - margin;
              x2 = Number(year_div[i + 1]) * ctrlWidth - margin;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }

            texts.push({
              x: x1 + ((x2 - x1) / 2),
              y: -5,
              text: date.get('year').toString(),
              textAnchor: 'middle',
              foreColor: '#b8c2cc',
              fontSize: '14px',
              appendTo: '.apexcharts-grid',
            })

            bgColorIdx += 1
          }

          if (this.chartID != 'comLnChart') {
            for (let i = 0; i < newVal.length; i++) {
              const markers = newVal[i].markers;

              for (let j = 0; j < markers.length; j++) {
                if (markers[j] > 0) 
                  points.push({
                    x: this.chartCategories[j],
                    y: newVal[i].data[j],
                    seriesIndex: i,
                    marker: {
                      size: 0
                    },
                    label: {
                      offsetY: 0,
                      borderColor: '#00000000',
                      orientation: 'horizontal',
                      style: {
                        color: colors[i],
                        background: '#00000000',
                        fontSize: '13px',
                      },
                      text: Number(newVal[i].data[j]).toLocaleString(),
                      textAnchor: 'middle',
                      position: 'top',
                    },
                    image: {
                      id: 'test',
                      path: data_uri_neg,
                      offsetY: -27,
                      width: 10,
                      height: 10,
                    },
                  })

                if (markers[j] < 0) 
                  points.push({
                    x: this.chartCategories[j],
                    y: newVal[i].data[j],
                    seriesIndex: i,
                    marker: {
                      size: 0
                    },
                    label: {
                      offsetY: 25,
                      borderColor: '#00000000',
                      orientation: 'horizontal',
                      style: {
                        color: colors[i],
                        background: '#00000000',
                        fontSize: '13px',
                      },
                      text: Number(newVal[i].data[j]).toLocaleString(),
                      textAnchor: 'middle',
                      position: 'top',
                    },
                    image: {
                      id: 'test',
                      path: data_uri_pos,
                      offsetY: 27,
                      width: 10,
                      height: 10,
                    },
                  })
              }
            }
          }

          this.series = newVal;

          const lineChartOption = {
            chart: {
              id: this.chartID,
            },
            xaxis: {
              categories: this.chartCategories,
            },
            colors: colors,
            markers: {
              shape: shapes,
            },
            annotations: {
              xaxis: xaxis,
              points: points,
              texts: texts
            },
          };

          this.$refs.brandindexLineChart.updateOptions(lineChartOption, true);
        });
      }
      else {
        const lineChartOption = {
          chart: {
            id: this.chartID,
          },
          noData: {
            text: '해당하는 키워드가 없습니다.',
            style: {
              color: '#FF009C',
            }
          },
        };

        this.$refs.brandindexLineChart.updateOptions(lineChartOption, true);
      }
    },

    updateHighlight: _.debounce(function(newVal) {
      // this.$nextTick();
      // this.$apexcharts.exec(this.chartID, 'highlightSeries', newVal)
    }, 1),
  },

  methods: {
    getCtrlRect() {
      var apexchart_grid = document.getElementById('apexcharts' + this.chartID).getElementsByClassName('apexcharts-grid-borders')
      return apexchart_grid[0].getBoundingClientRect();
    },

    getYearDivision() {
      var years = [];
      var year_div = [];
      var cur_year = 0;

      for (let i = 0; i < this.chartCategories.length; i++) {
        var date = moment(this.chartCategories[i])

        if (cur_year != date.get('year')) {
          cur_year = date.get('year');

          if (i > 0)
            year_div.push(i);
        }

        if (years.indexOf(date.get('year')) < 0) {
          years.push(date.get('year'));
          year_div.push(i);
        }
      }

      if (year_div.indexOf(this.chartCategories[this.chartCategories.length - 1]) < 0)
        year_div.push(this.chartCategories.length - 1);

      return year_div;
    },

    handleResize(event) {
      if (this.$el.offsetParent === null) {
        return;
      }

      isUpdateGrid = true

      var xaxis = [];
      var texts = [];
      var bgColorIdx = 0;

      if (this.series.length > 0) {   
        var year_div = this.getYearDivision();

        this.$nextTick(() => {
          const ctrlWidth = this.getCtrlRect().width / Number(this.chartCategories.length - 1);
          const margin = ctrlWidth / 2;

          for (let i = 0; i < year_div.length; i += 2) {
            var x1 = 0;
            var x2 = 0;

            var date = moment(this.chartCategories[year_div[i]])

            if (i == 0) {
              x1 = 0;
              x2 = Number(year_div[i + 1]) * ctrlWidth - margin;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }
            else if (i == year_div.length - 2) {
              x1 = Number(year_div[i]) * ctrlWidth - margin;
              x2 = Number(year_div[i + 1]) * ctrlWidth;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }
            else {
              x1 = Number(year_div[i]) * ctrlWidth - margin;
              x2 = Number(year_div[i + 1]) * ctrlWidth - margin;

              xaxis.push({
                x: x1,
                x2: x2,
                fillColor: bgcolorMap[bgColorIdx % 2],
                opacity: 0.1,
                strokeDashArray: 3,
                borderColor: '#050505',
              })
            }

            texts.push({
              x: x1 + ((x2 - x1) / 2),
              y: -5,
              text: date.get('year').toString(),
              textAnchor: 'middle',
              foreColor: '#b8c2cc',
              fontSize: '14px',
              appendTo: '.apexcharts-grid',
            })

            bgColorIdx += 1
          }

          const lineChartOption = {
            annotations: {
              xaxis: xaxis,
              texts: texts
            },
          };

          if (this.$refs.brandindexLineChart)
            this.$refs.brandindexLineChart.updateOptions(lineChartOption, true);
        });
      }
    },

    findLineByLeastSquares(values_x, values_y) {
      var x_sum = 0;
      var y_sum = 0;
      var xy_sum = 0;
      var xx_sum = 0;
      var count = 0;

      /*
      * The above is just for quick access, makes the program faster
      */
      var x = 0;
      var y = 0;
      var values_length = values_x.length;

      if (values_length != values_y.length) {
          throw new Error('The parameters values_x and values_y need to have same size!');
      }

      /*
      * Above and below cover edge cases
      */
      if (values_length === 0) {
          return [ [], [] ];
      }

      /*
      * Calculate the sum for each of the parts necessary.
      */
      for (let i = 0; i< values_length; i++) {
          x = values_x[i];
          y = values_y[i];
          x_sum+= x;
          y_sum+= y;
          xx_sum += x*x;
          xy_sum += x*y;
          count++;
      }

      /*
      * Calculate m and b for the line equation:
      * y = x * m + b
      */
      var m = (count*xy_sum - x_sum*y_sum) / (count*xx_sum - x_sum*x_sum);
      var b = (y_sum/count) - (m*x_sum)/count;

      /*
      * We then return the x and y data points according to our fit
      */
      var result_values_x = [];
      var result_values_y = [null,null,null,null];

      for (let i = 0; i < values_length; i++) {
          x = values_x[i];
          y = Math.round(x * m + b);
          result_values_x.push(x);
          if (i >= 4)
            result_values_y.push(y);
      }

      return [result_values_x, result_values_y];
    },

    findLineByMovingAverage(values) {
      const range = 5;
      var values_length = values.length;

      /*
      * Above and below cover edge cases
      */
      if (values_length === 0) {
          return [];
      }

      var prev_ema = 0;
      var exp_coef = 2 / (range + 1);
      var result_values = [];
      for (let i = 0; i < values_length; i++) {
        if (i < range - 1)
          result_values.push(null);
        else {
          var sum = 0;

          for (let j = i - (range - 1); j <= i; j++)
            sum += values[j];

          result_values.push(sum / range);
        }
        // if (i < 1) {
        //   result_values.push(values[i]);
        //   prev_ema = values[i];
        // }
        // else {
        //   result_values.push(values[i] * exp_coef + prev_ema * (1 - exp_coef));
        //   prev_ema = values[i];
        // }
      }
      return result_values;
    },

    async updateGridSize(container) {
      const gridEl = container.querySelector('.apexcharts-grid-borders')

      if (!gridEl) return

      this.debouncedResize()
    },
 
    waitForGrid(container) {
      return new Promise((resolve, reject) => {
        const existing = container.querySelector('.apexcharts-grid-borders')
        if (existing) return resolve(existing)

        const timer = setTimeout(() => {
          mutationObserver?.disconnect()
          reject(new Error('apexcharts-grid 감지 타임아웃'))
        }, 200)

        mutationObserver = new MutationObserver(() => {
          const el = container.querySelector('.apexcharts-grid-borders')

          if (el) {
            clearTimeout(timer)
            mutationObserver.disconnect()
            resolve(el)
          }
        })

        mutationObserver.observe(container, { childList: true, subtree: true })
      })
    },
  },

  created() {
    this.debouncedResize = _.debounce(this.handleResize, 200)
    this.debouncedUpdate = _.debounce((el) => { this.updateGridSize(el) }, 200)
  },

  mounted(){
    console.log('---------- mounted ----------')
    console.log('--> add event : windows resize')
    window.addEventListener('resize', this.debouncedResize);
  },

  destroyed() {
    console.log('---------- unmounted ----------')
    console.log('--> remove event : windows resize')
    window.removeEventListener('resize', this.debouncedResize);

    if (resizeObserver)
      resizeObserver.disconnect()

    if (mutationObserver)
      mutationObserver.disconnect()
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";

.brdlnchart .apexcharts-canvas .apexcharts-legend-series .apexcharts-legend-text {
  color: #6e6b7b !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  padding-left: 0px;
}

.brdlnchart .apexcharts-canvas .apexcharts-tooltip .apexcharts-tooltip-title {
  font-size: 12px !important;
  font-weight: 600;
}

.brdlnchart .apexcharts-canvas .apexcharts-tooltip-text {
  font-family: NanumBarunGothic !important;
  font-weight: 400;
  font-size: 10px !important;
  filter: none;
}

.brdlnchart .apexcharts-tooltip-marker {
  width: 8px;
  height: 8px;
  position: relative;
  top: 0px;
  margin-right: 5px;
  border-radius: 50%;
}

.brdlnchart .apexcharts-canvas .apexcharts-text {
  font-family: NanumBarunGothicB !important;
}

</style>
  